export default __webpack_public_path__ + "static/media/1656.a9cf2aff.png";